import { render, staticRenderFns } from "./YonetimDetay.vue?vue&type=template&id=c2db67d8&scoped=true&"
import script from "./YonetimDetay.vue?vue&type=script&lang=js&"
export * from "./YonetimDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2db67d8",
  null
  
)

export default component.exports